import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import ImageLink from "../Media/ImageLink";
import Link from "../Global/Link";
import SocialLinks from "../Global/SocialLinks";
import SmartText from "../../utils/TextHandler";
import LanguageToggle from "../Global/LanguageToggle";

const Footer = (props) => {
  const { location, settings } = props;

  const country = useSelector((state) => state.global.country);

  const [socialLinks, setSocialLinks] = useState([]);

  const parseNavigationLink = (navLink) => {
    // Only perform processing on home link
    if (navLink?.story?.slug !== "home") {
      return navLink;
    }

    // For english just return standard home string
    if (country === "default" || country === "gb") {
      return "/";
    }

    // For other languages prepend the country code
    return typeof country !== "undefined" ? `${country}/` : "/";
  };

  const footerIconsList = settings?.footer_icons?.map((icon, index) => {
    return (
      <li className="list-inline-item m-3 mt-0 m-md-0 me-md-4" key={index}>
        <ImageLink data={icon} sm="0x50" md="0x100" lg="0x100" />
      </li>
    );
  });

  const navigationLinksList =
    settings.navigation &&
    settings.navigation.reduce((currList, item, index) => {
      if (item && item.link) {
        currList.push(
          <li className="list-inline-item" key={index}>
            <Link
              className="text-uppercase brand-copy-font
            brand-font-size-XS brand-font-weight-400 brand-line-height-14 brand-text-white"
              // to={item.link?.story?.slug === "home" ? "/" : item.link}
              to={parseNavigationLink(item.link)}
            >
              {item.name}
            </Link>
          </li>
        );
      }
      return currList;
    }, []);

  useEffect(() => {
    if (country === "zh") {
      setSocialLinks([
        { iconName: "weibo", link: settings?.weibo },
        { iconName: "bilibili", link: settings?.bilibili },
        { iconName: "", link: settings?.heybox, isHeybox: true },
        { iconName: "tiktok", link: settings?.douyin },
      ]);
    } else {
      setSocialLinks([
        { iconName: "facebook-f", link: settings?.facebook },
        { iconName: "twitter", link: settings?.twitter },
        { iconName: "instagram", link: settings?.instagram },
        { iconName: "tiktok", link: settings?.tiktok },
        { iconName: "discord", link: settings?.discord },
      ]);
    }
  }, [
    country,
    location,
    settings?.weibo,
    settings?.bilibili,
    settings?.heybox,
    settings?.facebook,
    settings?.twitter,
    settings?.instagram,
    settings?.tiktok,
    settings?.discord,
    settings?.douyin,
  ]);

  return (
    <footer className="w-100 brand-index-top">
      <div className="d-flex flex-row justify-content-between brand-background-border brand-background-border-bottom position-absolute w-100 start-0 end-0">
        <img
          src="https://a.storyblok.com/f/156499/60x72/145c776cc9/border-bottom-left.png"
          alt=""
        />
        <img
          src="https://a.storyblok.com/f/156499/60x72/226b6b11ad/border-bottom-right.png"
          alt=""
        />
      </div>
      <div className="container-fluid small py-5 brand-background-black">
        <div className="row align-items-start px-3 pb-4 gy-5">
          <div className="col-12 col-md-8 text-center text-md-start d-flex flex-column justify-content-between order-1 order-md-0">
            <div className="d-flex flex-column justify-content-start">
              <ul className="list-inline">{footerIconsList}</ul>

              <ul className="list-inline brand-footer-nav-links">
                {navigationLinksList}
              </ul>
            </div>

            <div className="w-100 brand-text-footer-grey small">
              <SmartText content={settings?.footer} mode="simple" />
            </div>
          </div>

          <div className="col-12 col-md-4 text-center text-md-end d-flex flex-column justify-content-between order-0 order-md-1 pt-0 pt-md-3">
            <SocialLinks
              className="d-flex flex-row justify-content-center justify-content-md-end mb-5"
              itemClassName="mx-2 fs-2 brand-background-white brand-link-black rounded rounded-circle ratio ratio-1x1 brand-social-icon"
              links={socialLinks}
            />

            <LanguageToggle settings={settings}></LanguageToggle>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

Footer.propTypes = {
  settings: PropTypes.object,
};

Footer.defaultProps = {
  settings: null,
};
